import React, { useContext } from "react";
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import GroupApprovers from "../FieldTags/GroupApprovers";
import { UserContext } from "../../context/UserContext";
import xplanLabels from "../../util/XplanLabels";
import ROLES from "../../util/roles";
import HistoryLogElement from "./HistoryLogElement";
import { checkRole } from "../../util/FormUtils";

const newPlan = window.location.pathname === "/xplans/new";

const SampleDisposal = ({ sampleDisposal, handleSampleDisposalChange, xplans }) => {
    const { user } = useContext(UserContext);
    const canEdit = checkRole(user, [ROLES.BIOLOGIST, ROLES.APPROVER]);

    return (
        <div id="sampleDisposal" className="planField">
            <GroupApprovers />
            <FormControl required={true}>
                <FormLabel className="planRadioTitle">
                    {xplanLabels.sampleDisposal}
                </FormLabel>
                <RadioGroup
                    name="sampleDisposal"
                    label={xplanLabels.sampleDisposal}
                    value={sampleDisposal}
                    onChange={(e) => handleSampleDisposalChange("sampleDisposal", e.target.value)}
                    row
                >
                    <FormControlLabel
                        value="Yes"
                        control={<Radio disabled={!canEdit} />}
                        label="Yes"
                    />
                    <FormControlLabel
                        value="No"
                        control={<Radio disabled={!canEdit} />}
                        label="No"
                    />
                </RadioGroup>
            </FormControl>
            {!newPlan && <HistoryLogElement xplans={xplans} label={"sampleDisposal"} />}
        </div>
    );
};

export default SampleDisposal;